import { MigrationInterface, QueryRunner } from 'typeorm'

export class AddBillingProfile1699888709315 implements MigrationInterface {
	name = 'AddBillingProfile1699888709315'

	public async up(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(
			`CREATE TABLE "billing_profile" ("id" uuid NOT NULL DEFAULT uuid_generate_v4(), "createdAt" TIMESTAMP NOT NULL DEFAULT now(), "tenantId" uuid, "createdBy" uuid, "lastUpdatedAt" TIMESTAMP NOT NULL DEFAULT now(), "lastUpdatedBy" uuid, "stripeAccountId" text NOT NULL, "profile" json, CONSTRAINT "PK_6408c6bdc5bcdf6ef353599e833" PRIMARY KEY ("id"))`,
		)
	}

	public async down(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`DROP TABLE "billing_profile"`)
	}
}
